<button class="kh-student-btn" [ngClass]="{
        'kh-student-btn-primary' : types.primary === type,
        'kh-student-btn-secondary' : types.secondary === type,
        'kh-student-btn-tertiary' : types.tertiary === type,
        'kh-student-btn-highlight' : types.highlight === type,
        'kh-student-btn-danger' : types.danger === type,
        'kh-student-btn-sm' : sizes.sm === size,
        'kh-student-btn-md' : sizes.md === size,
        'kh-student-btn-lg' : sizes.lg === size,
        'kh-student-btn-fill-width' : fillWidth === true
    }" [disabled]="disabled">

    <span #ref class="d-flex justify-content-center align-items-center">
        <ng-content></ng-content>
    </span>
    <span *ngIf="!ref.innerHTML.trim()">
        {{text}}
    </span>

</button>
